module.exports = __webpack_public_path__ + "static/componentsOrTextStylesNo-5c94e2c438a448158ee559e2a82b014c.png";